import { Modal, QRCode, Spin } from 'antd';
import { useTranslation } from 'react-i18next';

interface AdminQRModalProps {
	qrCodeModalOpen: boolean;
	setQrCodeModalOpen: (val: boolean) => void;
	closable: boolean;
	qrCodeUrl: string;
	loading: boolean;
}

const AdminQRCodeModal = (props: AdminQRModalProps) => {
	const { t } = useTranslation();
	const {
		qrCodeModalOpen,
		setQrCodeModalOpen,
		closable,
		qrCodeUrl = '',
		loading
	} = props;

	return (
		<Modal
			open={qrCodeModalOpen}
			centered
			footer={null}
			destroyOnClose
			closable={closable}
			maskClosable={false}
			width={500}
			className="select-none"
			onCancel={() => setQrCodeModalOpen(false)}>
			<div style={{ textAlign: 'center', padding: '20px' }}>
				<h1 style={{ marginBottom: '20px' }}>
					{t('Admin.data.menu.setting.scanQR')}
				</h1>
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						marginBottom: '20px',
					}}>
					{(loading || qrCodeUrl?.length == 0) ? (
						<div style={{ margin: 20 }}>
							<Spin tip="Loading" size="large" />
							<p style={{ marginTop: 20 }}>{t('Patient.data.omnirom.generating')}</p>
						</div>
					) : (
						<QRCode value={qrCodeUrl} size={300} />
					)}
				</div>
			</div>
		</Modal>
	);
};

export default AdminQRCodeModal;
